module.exports = __webpack_public_path__ + "img/emoji_76.0271f15f.png";